import { Card } from 'antd';
import { Title } from 'components';

import ArticleRelationDataTable from './article-relation-data-table';

function ArticleRelationManagement() {
  return (
    <Card>
      <Title>Madde İlişkileri Yönetimi</Title>
      <h2 className="gx-h1-lg">Madde İlişkileri Yönetimi</h2>
      <p>Ansiklopedi maddeleri arasındaki ilişkileri düzenleyebilirsiniz.</p>
      <ArticleRelationDataTable />
    </Card>
  );
}
export default ArticleRelationManagement;
